module.exports = __webpack_public_path__ + "methodology-image.png?e3e193e9efdde155e929a7733e703c56";